import { createAccount } from '../accounts'
import { createAccountDocument } from '../accountDocument'
import { createCall } from '../calls'
import { createCase } from '../cases'
import { createCaseReply } from '../caseReply'
import { createCaseNote } from '../caseNote'
import { createCaseDocument } from '../caseDocument'
import { createCaseType } from '../selectLists/caseTypes'
import { createServiceRequest } from '../serviceRequests'
import { createServiceRequestReply } from '../serviceRequestReply'
import { createServiceRequestNote } from '../serviceRequestNote'
import { createServiceRequestDocument } from '../serviceRequestDocument'
import { createServiceRequestType } from '../selectLists/serviceRequestTypes'
import { createCompany } from '../companies'
import { createCompanyContact } from '../companyContacts'
import { createCompanyContactRole } from '../selectLists/companyContactRoles'
import { createCompanyLastSelectedState } from '../companyLastSelectedState'
import { createCompanyMasterService } from '../companyMasterServices'
import { createCompanyMSContact } from '../companyMSContacts'
import { createCompanyMSService } from '../companyMSServices'
import { createCompanyMSTeamMember } from '../companyMSTeamMembers'
import { createCompanyTeamMember } from '../companyTeamMembers'
import { createContract } from '../contracts'
import { createCompanyDocument } from '../companyDocument'
import { createCompanyMSDocument } from '../companyMSDocument'
import { createCompanyMSServiceDocument } from '../companyMSServiceDocument'
import { createContractDocument } from '../contractDocument'
import { createEmail } from '../emails'
import { createFeedback } from '../feedback'
import { createFieldSet } from '../fieldSets'
import { createFieldSetField } from '../fieldSetFields'
import { createGroup } from '../groups'
import { createIndustry } from '../selectLists/industries'
import { createLeadSourceCampaign } from '../selectLists/leadSourceCampaigns'
import { createLeadSourceContact } from '../selectLists/leadSourceContacts'
import { createLeadSourceEvent } from '../selectLists/leadSourceEvents'
import { createLocation } from '../locations'
import { createLocationDocument } from '../locationDocument'
import { createLocationType } from '../selectLists/locationTypes'
import { createLocationHardwareCompanyOwnedItem } from '../locationHardwareCompanyOwnedItems'
import { createLocationHardwareTenantOwnedItem } from '../locationHardwareTenantOwnedItems'
import { createLocationCompanyContact } from '../locationCompanyContacts'
import { createOrder } from '../orders'
import { createOrderLastSelectedState } from '../orderLastSelectedState'
import { createOrderMasterService } from '../orderMasterServices'
import { createOrderMSService } from '../orderMSServices'
import { createOrderTeamMember } from '../orderTeamMembers'
import { createOrderDocument } from '../orderDocument'
import { createOrderMSDocument } from '../orderMSDocument'
import { createOrderMSServiceDocument } from '../orderMSServiceDocument'
import { createOrderMSTeamMember } from '../orderMSTeamMembers'
import { createOrderContact } from '../orderContacts'
import { createOrderMSContact } from '../orderMSContacts'
import { createOrderServiceOrder } from '../orderServiceOrders'
import { createMeeting } from '../meetings'
import { createOpportunity } from '../opportunities'
import { createOpportunityDocument } from '../opportunityDocument'
import { createOpportunityMSDocument } from '../opportunityMSDocument'
import { createOpportunityMSServiceDocument } from '../opportunityMSServiceDocument'
import { createOpportunityNote } from '../opportunityNote'
import { createOpportunityMSNote } from '../opportunityMSNote'
import { createOpportunityMSServiceNote } from '../opportunityMSServiceNote'
import { createCompanyNote } from '../companyNote'
import { createCompanyMSNote } from '../companyMSNote'
import { createCompanyMSServiceNote } from '../companyMSServiceNote'
import { createOrderNote } from '../orderNote'
import { createOrderMSNote } from '../orderMSNote'
import { createOrderMSServiceNote } from '../orderMSServiceNote'
import { createLocationNote } from '../locationNote'
import { createSupplierNote } from '../supplierNote'
import { createSupplierProductNote } from '../supplierProductNote'
import { createTsdNote } from '../tsdNote'
import { createAccountNote } from '../accountNote'
import { createContractNote } from '../contractNote'
import { createOpportunityLastSelectedState } from '../opportunityLastSelectedState'
import { createOpportunityMasterService } from '../opportunityMasterServices'
import { createOpportunityMSService } from '../opportunityMSServices'
import { createOpportunityRegistration } from '../opportunityRegistration'
import { createOpportunityTeamMember } from '../opportunityTeamMembers'
import { createOpportunityMSTeamMember } from '../opportunityMSTeamMembers'
import { createOpportunityContact } from '../opportunityContacts'
import { createOpportunityMSContact } from '../opportunityMSContacts'
import { createOpportunityStage } from '../selectLists/opportunityStages'
import { createPerson } from '../persons'
import { createProject } from '../projects'
import { createProduct } from '../products'
import { createProductCategory } from '../productCategories'
import { createProductGroup } from '../productGroups'
import { createProductSubcategory } from '../productSubcategories'
import { createProductKitItem } from '../productKitItems'
import { createSubindustry } from '../selectLists/subindustries'
import { createSupplier } from '../suppliers'
import { createSupplierLastSelectedState } from '../supplierLastSelectedState'
import { createSupplierContact } from '../supplierContacts'
import { createSupplierContactRole } from '../selectLists/supplierContactRoles'
import { createSupplierDocument } from '../supplierDocument'
import { createSupplierProduct } from '../supplierProducts'
import { createSupplierProductDocument } from '../supplierProductDocument'
import { createSupplierProductItem } from '../supplierProductItems'
import { createSupplierResource } from '../supplierResources'
import { createTask } from '../task'
import { createTeamMember } from '../teamMembers'
import { createTeamMemberLastSelectedState } from '../teamMemberLastSelectedState'
import { createTsd } from '../tsds'
import { createTsdContact } from '../tsdContacts'
import { createTsdContactRole } from '../selectLists/tsdContactRoles'
import { createTsdDocument } from '../tsdDocument'
import { createTsdSupplier } from '../tsdSuppliers'
import { createTsdResource } from '../tsdResources'
import { createUser } from '../users'

interface CreateEntityNamedArgs {
  entityName: string
  entity: any
}

export async function createEntity({
  entityName,
  entity,
}: CreateEntityNamedArgs) {
  switch (entityName) {
    case 'account':
      return await createAccount(entity)
    case 'accountDocument':
      return await createAccountDocument(entity)

    case 'call':
      return await createCall(entity)

    case 'case':
      return await createCase(entity)
    // Not a collection: `caseReply` resolves to POST /api/cases/{id}/replies,
    // an action. Routed through here so the reply uses the standard dialog and
    // input-spec machinery like every other write.
    case 'caseReply':
      return await createCaseReply(entity)
    case 'caseDocument':
      return await createCaseDocument(entity)
    case 'caseNote':
      return await createCaseNote(entity)
    case 'caseType':
      return await createCaseType(entity)

    // Forked from the case* entries above (`cases-pre-sr-fork`).
    case 'serviceRequest':
      return await createServiceRequest(entity)
    case 'serviceRequestReply':
      return await createServiceRequestReply(entity)
    case 'serviceRequestDocument':
      return await createServiceRequestDocument(entity)
    case 'serviceRequestNote':
      return await createServiceRequestNote(entity)
    case 'serviceRequestType':
      return await createServiceRequestType(entity)

    case 'company':
      return await createCompany(entity)
    case 'companyContact':
      return await createCompanyContact(entity)
    case 'companyContactRole':
      return await createCompanyContactRole(entity)
    case 'companyDocument':
      return await createCompanyDocument(entity)
    case 'companyLastSelectedState':
      return await createCompanyLastSelectedState(entity)
    case 'companyMasterService':
      return await createCompanyMasterService(entity)
    case 'companyMSContact':
      return await createCompanyMSContact(entity)
    case 'companyMSDocument':
      return await createCompanyMSDocument(entity)
    case 'companyMSService':
      return await createCompanyMSService(entity)
    case 'companyMSServiceDocument':
      return await createCompanyMSServiceDocument(entity)
    case 'companyMSTeamMember':
      return await createCompanyMSTeamMember(entity)
    case 'companyTeamMember':
      return await createCompanyTeamMember(entity)

    case 'contract':
      return await createContract(entity)
    case 'contractDocument':
      return await createContractDocument(entity)

    case 'email':
      return await createEmail(entity)

    case 'feedback':
      return await createFeedback(entity)

    case 'fieldSet':
      return await createFieldSet(entity)
    case 'fieldSetField':
      return await createFieldSetField(entity)

    case 'group':
      return await createGroup(entity)

    case 'industry':
      return await createIndustry(entity)

    case 'leadSourceCampaign':
      return await createLeadSourceCampaign(entity)
    case 'leadSourceContact':
      return await createLeadSourceContact(entity)
    case 'leadSourceEvent':
      return await createLeadSourceEvent(entity)

    case 'location':
      return await createLocation(entity)
    case 'locationDocument':
      return await createLocationDocument(entity)
    case 'locationHardwareCompanyOwnedItem':
      return await createLocationHardwareCompanyOwnedItem(entity)
    case 'locationHardwareTenantOwnedItem':
      return await createLocationHardwareTenantOwnedItem(entity)
    case 'locationCompanyContact':
      return await createLocationCompanyContact(entity)
    case 'locationType':
      return await createLocationType(entity)

    case 'order':
      return await createOrder(entity)
    case 'orderContact':
      return await createOrderContact(entity)
    case 'orderDocument':
      return await createOrderDocument(entity)
    case 'orderLastSelectedState':
      return await createOrderLastSelectedState(entity)
    case 'orderMasterService':
      return await createOrderMasterService(entity)
    case 'orderMSContact':
      return await createOrderMSContact(entity)
    case 'orderMSDocument':
      return await createOrderMSDocument(entity)
    case 'orderMSService':
      return await createOrderMSService(entity)
    case 'orderMSServiceDocument':
      return await createOrderMSServiceDocument(entity)
    case 'orderMSTeamMember':
      return await createOrderMSTeamMember(entity)
    case 'orderServiceOrder':
      return await createOrderServiceOrder(entity)
    case 'orderTeamMember':
      return await createOrderTeamMember(entity)

    case 'meeting':
      return await createMeeting(entity)

    case 'opportunity':
      return await createOpportunity(entity)
    case 'opportunityDocument':
      return await createOpportunityDocument(entity)
    case 'opportunityMSDocument':
      return await createOpportunityMSDocument(entity)
    case 'opportunityMSServiceDocument':
      return await createOpportunityMSServiceDocument(entity)
    case 'opportunityNote':
      return await createOpportunityNote(entity)
    case 'opportunityMSNote':
      return await createOpportunityMSNote(entity)
    case 'opportunityMSServiceNote':
      return await createOpportunityMSServiceNote(entity)
    case 'companyNote':
      return await createCompanyNote(entity)
    case 'companyMSNote':
      return await createCompanyMSNote(entity)
    case 'companyMSServiceNote':
      return await createCompanyMSServiceNote(entity)
    case 'orderNote':
      return await createOrderNote(entity)
    case 'orderMSNote':
      return await createOrderMSNote(entity)
    case 'orderMSServiceNote':
      return await createOrderMSServiceNote(entity)
    case 'locationNote':
      return await createLocationNote(entity)
    case 'supplierNote':
      return await createSupplierNote(entity)
    case 'supplierProductNote':
      return await createSupplierProductNote(entity)
    case 'tsdNote':
      return await createTsdNote(entity)
    case 'accountNote':
      return await createAccountNote(entity)
    case 'contractNote':
      return await createContractNote(entity)
    case 'opportunityLastSelectedState':
      return await createOpportunityLastSelectedState(entity)
    case 'opportunityMasterService':
      return await createOpportunityMasterService(entity)
    case 'opportunityMSService':
      return await createOpportunityMSService(entity)
    case 'opportunityRegistration':
      return await createOpportunityRegistration(entity)
    case 'opportunityTeamMember':
      return await createOpportunityTeamMember(entity)
    case 'opportunityMSTeamMember':
      return await createOpportunityMSTeamMember(entity)
    case 'opportunityContact':
      return await createOpportunityContact(entity)
    case 'opportunityMSContact':
      return await createOpportunityMSContact(entity)
    case 'opportunityStage':
      return await createOpportunityStage(entity)

    case 'person':
      return await createPerson(entity)
    case 'project':
      return await createProject(entity)

    case 'product':
      return await createProduct(entity)
    case 'productCategory':
      return await createProductCategory(entity)
    case 'productGroup':
      return await createProductGroup(entity)
    case 'productKitItem':
      return await createProductKitItem(entity)
    case 'productSubcategory':
      return await createProductSubcategory(entity)

    case 'subindustry':
      return await createSubindustry(entity)

    case 'supplier':
      return await createSupplier(entity)
    case 'supplierLastSelectedState':
      return await createSupplierLastSelectedState(entity)
    case 'supplierContact':
      return await createSupplierContact(entity)
    case 'supplierContactRole':
      return await createSupplierContactRole(entity)
    case 'supplierDocument':
      return await createSupplierDocument(entity)
    case 'supplierProduct':
      return await createSupplierProduct(entity)
    case 'supplierProductDocument':
      return await createSupplierProductDocument(entity)
    case 'supplierProductItem':
      return await createSupplierProductItem(entity)
    case 'supplierResource':
      return await createSupplierResource(entity)

    case 'task':
      return await createTask(entity)

    case 'teamMember':
      return await createTeamMember(entity)
    case 'teamMemberLastSelectedState':
      return await createTeamMemberLastSelectedState(entity)

    case 'tsd':
      return await createTsd(entity)
    case 'tsdSupplier':
      return await createTsdSupplier(entity)
    case 'tsdContact':
      return await createTsdContact(entity)
    case 'tsdContactRole':
      return await createTsdContactRole(entity)
    case 'tsdDocument':
      return await createTsdDocument(entity)
    case 'tsdResource':
      return await createTsdResource(entity)

    case 'user':
      return await createUser(entity)

    default:
      console.error(
        `[services/crud/createEntity] createEntity | Unknown entityName '${entityName}'`
      )
  }
}
